/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncLeadSOffenderRecordsByIdRequest
 */
export interface SyncLeadSOffenderRecordsByIdRequest {
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    dob?: string;
}

/**
 * Check if a given object implements the SyncLeadSOffenderRecordsByIdRequest interface.
 */
export function instanceOfSyncLeadSOffenderRecordsByIdRequest(value: object): value is SyncLeadSOffenderRecordsByIdRequest {
    return true;
}

export function SyncLeadSOffenderRecordsByIdRequestFromJSON(json: any): SyncLeadSOffenderRecordsByIdRequest {
    return SyncLeadSOffenderRecordsByIdRequestFromJSONTyped(json, false);
}

export function SyncLeadSOffenderRecordsByIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncLeadSOffenderRecordsByIdRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'dob': json['dob'] == null ? undefined : json['dob'],
    };
}

export function SyncLeadSOffenderRecordsByIdRequestToJSON(json: any): SyncLeadSOffenderRecordsByIdRequest {
    return SyncLeadSOffenderRecordsByIdRequestToJSONTyped(json, false);
}

export function SyncLeadSOffenderRecordsByIdRequestToJSONTyped(value?: SyncLeadSOffenderRecordsByIdRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'dob': value['dob'],
    };
}

